<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="700">
    <v-card v-if="row != null">
      <ODialogBar
        title="Histórico de Câmera"
        :subtitle="subtitle"
        @close="dismiss"
      />

      <v-card-text class="pa-3">
        <div class="d-flex flex-row justify-space-between pa-3">
          <OCapCont label="Câmera">
            {{ row.camera.name }}
            <span class="mono tiny grey--text text--lighten-1">
              (#{{ row.cameraId }})
            </span>
          </OCapCont>

          <OCapCont label="Lote" >
            {{ row.camera.batchNumber }}
          </OCapCont>

          <OCapCont label="IMEI" >
            {{ row.camera.imei }}
          </OCapCont>
        </div>
        <div class="d-flex flex-row pa-3">
          <OCapCont label="Técnico" class="w-3/4">
            {{ row.technician.name }}
            <span class="mono tiny grey--text text--lighten-1">
              (#{{ row.technicianId }})
            </span>
          </OCapCont>

          <OCapCont label="Valor Técnico" class="w-1/4">
            {{ row.techValue | brMoney }}
          </OCapCont>
        </div>
        <div class="d-flex flex-row pa-3">
          <OCapCont label="Centro de Custo" class="w-3/4">
            {{ row.costCenter.name }}
            <span class="mono tiny grey--text text--lighten-1">
              (#{{ row.costCenterId }})
            </span>
          </OCapCont>

          <OCapCont label="Valor CC" class="w-1/4">
            {{ row.costCenterValue | brMoney }}
          </OCapCont>
        </div>
        <div class="d-flex flex-row pa-3">
          <OCapCont label="Veículo" class="w-full">
            <div>
              {{ row.vehicle.code }}
              <span v-if="row.vehicle.extraCode">
                ─ {{ row.vehicle.extraCode }}
              </span>
              <span class="mono tiny grey--text text--lighten-1">
                (#{{ row.vehicleId }})
              </span>
            </div>

            <OTagList class="small mt-2" :value="row.vehicle.tags" />
          </OCapCont>
        </div>
        <div class="d-flex flex-row flex-wrap pa-3">
          <OCapCont label="Histórico" class="w-3/4">
            <span v-if="row.type == 'install'" class="tag green"
              >Instalação</span
            >
            <span v-else-if="row.type == 'remove'" class="tag red"
              >Retirada</span
            >
            <span v-else class="tag yellow">Intervenção</span>

            em {{ row.timestamp | moment('DD/MM/YYYY HH:mm') }}
          </OCapCont>

          <OCapCont label="Login" class="w-1/4">
            {{ row.login }}
          </OCapCont>

          <OCapCont label="Comentários" class="w-full mt-4">
            {{ row.comments }}
          </OCapCont>

          <span class="mt-8 mono small">
            Registro criado em {{ row.createdAt | moment }}, atualizado em
            {{ row.updatedAt | moment }}
          </span>
        </div>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { Camera } from './cameras-fetcher'
import { brMoney } from 'oderon-commons/src/formatters'
import { isEmpty } from 'oderon-commons/src/utils'

export default {
  data() {
    return this.reset()
  },
  computed: {
    subtitle() {
      if (this.id == null) return null
      return '#' + this.id
    }
  },
  filters: {
    brMoney(x) {
      if (isEmpty(x)) return '-'
      return brMoney(x)
    }
  },
  methods: {
    reset() {
      return {
        activeTab: 0,
        row: null,
        id: null
      }
    },
    open(id) {
      Object.assign(this, this.reset())
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    async fetchData() {
      this.row = await Camera.findHistoryById(this.id)
    }
  }
}
</script>

<style></style>
